import * as core from '../../../../../../../core'
import * as changeImpactYesNoNa from '../change-impact-yes-no-na'

export const RESOURCE = {
  payload: {
    description: 'N/A',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactYesNoNa.RESOURCE.payload.partialId,
    }),
    id: 'N/A',
    name: 'N/A',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
